// Data layer for the team dashboard. One cookie-authed GET /api/dashboard.

export interface DashboardMember { userId: string; email: string | null; role: string; }
export type DashboardResult =
  | { ok: true; team: { id: string; name: string } | null; role: string | null; joinCode: string | null; members: DashboardMember[] }
  | { ok: false; needsAuth?: boolean };

export async function fetchDashboard(apiBase = '', fetchImpl: typeof fetch = fetch): Promise<DashboardResult> {
  try {
    const res = await fetchImpl(`${apiBase}/api/dashboard`, { credentials: 'include' });
    if (res.status === 401) return { ok: false, needsAuth: true };
    if (!res.ok) return { ok: false };
    const body = await res.json() as any;
    return {
      ok: true,
      team: body?.team ?? null,
      role: body?.role ?? null,
      joinCode: body?.joinCode ?? null,
      members: Array.isArray(body?.members) ? body.members : [],
    };
  } catch {
    return { ok: false };
  }
}
